import { AutoCountTextControlFactory } from "./autoplay/auto-count-text-control-factory";
import { AutoLossLimitRadioControlFactory } from "./autoplay/auto-loss-limit-radio-control-factory";
import { AutoSingleWinRadioControlFactory } from "./autoplay/auto-single-win-radio-control-factory";
import { AutoSpinsCountRadioControlFactory } from "./autoplay/auto-spins-count-radio-control-factory";
import { AutoStartControlFactory } from "./autoplay/auto-start-control-factory";
import { AutoStopControlFactory } from "./autoplay/auto-stop-control-factory";
import { AutoplayControlFactory } from "./autoplay/autoplay-control-factory";
import { StopOnFeatureControlFactory } from "./autoplay/stop-on-feature-control-factory";
import { StopOnWinToggleControlFactory } from "./autoplay/stop-on-win-toggle-control-factory";

export function GetAutoplayFactories() {
    return [
        new AutoSpinsCountRadioControlFactory(),
        new AutoLossLimitRadioControlFactory(),
        new AutoSingleWinRadioControlFactory(),
        new AutoStartControlFactory(),
        new AutoStopControlFactory(),
        new AutoCountTextControlFactory(),
        new StopOnFeatureControlFactory(),
        new StopOnWinToggleControlFactory(),
        new AutoplayControlFactory()
    ];
}
